import HoursPlanningMonthWidget from "@/pages/employee/planning/widgets/HoursPlanningMonthWidget.vue";
import HourBalanceWidget from "@/pages/employee/planning/widgets/HourBalanceWidget.vue";
import HoursRealMonthWidget from "@/pages/employee/planning/widgets/HoursRealMonthWidget.vue";

export { HoursPlanningMonthWidget, HourBalanceWidget, HoursRealMonthWidget };
